module.exports = __webpack_public_path__ + "static/media/info-round.0f035ffd.svg";